export const TestCode6FixedChatsIds = [120980, 120976, 120983, 120994, 120991, 120995]

// export const TestCode6FixedChatsIds = [72024, 72025, 72029, 72028, 72026]
export default {
  TestCode6FixedChatsIds,
}
